const STORAGE_KEY = "uploadExcel_settings";

const DEFAULT = {
  includeInstructions: true,
  includeSampleData: true,
  customFileName: "",
  customFileNameByTitle: {}
};

export const getUploadExcelSettings = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT, ...parsed };
  } catch {
    return { ...DEFAULT };
  }
};

export const setUploadExcelSettings = (next) => {
  try {
    const current = getUploadExcelSettings();
    const merged = { ...current, ...next };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    return merged;
  } catch {
    return getUploadExcelSettings();
  }
};

export const getCustomFileNameForTitle = (title) => {
  const s = getUploadExcelSettings();
  if (title != null && title !== "") {
    const byTitle = s.customFileNameByTitle || {};
    if (byTitle[title] !== undefined) return byTitle[title];
  }
  return s.customFileName || "";
};

export const setCustomFileNameForTitle = (title, value) => {
  const s = getUploadExcelSettings();
  if (title != null && title !== "") {
    const byTitle = { ...(s.customFileNameByTitle || {}) };
    byTitle[title] = value;
    setUploadExcelSettings({ customFileNameByTitle: byTitle });
  } else {
    setUploadExcelSettings({ customFileName: value });
  }
};
